"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _arrowWhite = _interopRequireDefault(require("../../../assets/img/arrow-white.svg"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents["default"].label.withConfig({
  displayName: "checkbox__Label",
  componentId: "tc0gkx-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    line-height: 24px;\n    cursor: pointer;\n"])));

var Input = _styledComponents["default"].input.withConfig({
  displayName: "checkbox__Input",
  componentId: "tc0gkx-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    left: -9999px;\n"])));

var Checkmark = _styledComponents["default"].div.withConfig({
  displayName: "checkbox__Checkmark",
  componentId: "tc0gkx-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 22px;\n    height: 22px;\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 4px;\n    position: relative;\n    flex-shrink: 0;\n    margin-right: ", ";\n    :hover {\n        border: 1px solid ", ";\n    }\n    ", ":checked + ", " & {\n        border: 1px solid ", ";\n        background: ", ";\n        :hover {\n            background: ", ";\n            border: 1px solid ", ";\n        }\n        :before {\n            position: absolute;\n            display: block;\n            content: '';\n            width: 13px;\n            height: 10px;\n            top: 5px;\n            left: 4px;\n            background:  url(", ") no-repeat;\n            transition: 0.25s;\n        }  \n    }\n"])), _constants.COLORS.grey, function (props) {
  return props.disabled ? _constants.COLORS.grey : _constants.COLORS.white;
}, function (props) {
  return "".concat(props.mr, "px");
}, _constants.COLORS.darkGrey, Input, Label, function (props) {
  return props.disabled ? _constants.COLORS.grey : _constants.COLORS.lightGreen;
}, function (props) {
  return props.disabled ? _constants.COLORS.grey : _constants.COLORS.lightGreen;
}, function (props) {
  return props.disabled ? _constants.COLORS.grey : _constants.COLORS.green;
}, _constants.COLORS.green, _arrowWhite["default"]);

var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _super.apply(this, arguments);
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? 'checkbox' : _this$props$id,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          children = _this$props.children,
          mr = _this$props.mr,
          disabled = _this$props.disabled,
          rest = _objectWithoutProperties(_this$props, ["className", "id", "checked", "onChange", "children", "mr", "disabled"]);

      var change = disabled ? function () {} : onChange;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Input, _extends({
        id: id,
        type: "checkbox",
        onChange: change,
        checked: checked,
        disabled: disabled
      }, rest)), /*#__PURE__*/_react["default"].createElement(Label, {
        htmlFor: id,
        className: className
      }, /*#__PURE__*/_react["default"].createElement(Checkmark, {
        mr: mr ? mr : children ? 10 : 0,
        disabled: disabled
      }), children));
    }
  }]);

  return Checkbox;
}(_react.Component);

var _default = Checkbox;
exports["default"] = _default;